export type EventCategory = 'competition' | 'adherents' | 'autres'

export type ClubEvent = {
  date: string
  day: string
  month: string
  title: string
  place: string
  category: EventCategory
  detail: string
}

export const EVENT_CATEGORIES: { id: EventCategory; label: string; description: string }[] = [
  { id: 'competition', label: 'Compétitions', description: 'Dates et lieux des compétitions de la saison.' },
  { id: 'adherents', label: 'Évènements adhérents', description: 'Rendez-vous réservés aux adhérents du club.' },
  { id: 'autres', label: 'Autres évènements', description: 'Stages et démonstrations ouverts au public.' },
]

export const EVENTS: ClubEvent[] = [
  {
    date: '2026-10-11',
    day: '11',
    month: 'Oct.',
    title: 'Coupe départementale Kata',
    place: 'Gymnase Compans, Toulouse',
    category: 'competition',
    detail: 'Catégories pupilles à seniors. Départ groupé du dojo à 7h30.',
  },
  {
    date: '2026-11-08',
    day: '08',
    month: 'Nov.',
    title: 'Stage technique Shotokan',
    place: 'Dojo Fondada, Castelnau',
    category: 'autres',
    detail: 'Stage ouvert au public, animé par un expert fédéral. Inscription sur place.',
  },
  {
    date: '2026-12-13',
    day: '13',
    month: 'Déc.',
    title: 'Passage de grades — Kyu',
    place: 'Dojo Fondada, Castelnau',
    category: 'adherents',
    detail: 'Enfants de 14h à 15h30, adultes de 15h30 à 17h. Kimono propre exigé.',
  },
  {
    date: '2027-01-17',
    day: '17',
    month: 'Janv.',
    title: 'Championnat régional Kumite',
    place: 'Palais des Sports, Montauban',
    category: 'competition',
    detail: 'Sélection régionale Occitanie, qualificatif pour la demi-finale nationale.',
  },
  {
    date: '2027-02-07',
    day: '07',
    month: 'Févr.',
    title: 'Galette du club & assemblée',
    place: 'Salle des fêtes, Castelnau',
    category: 'adherents',
    detail: 'Moment convivial ouvert aux familles, suivi du bilan de mi-saison.',
  },
  {
    date: '2027-03-21',
    day: '21',
    month: 'Mars',
    title: 'Démonstration — Fête du sport',
    place: 'Parvis des Citoyens, Castelnau',
    category: 'autres',
    detail: 'Démonstration de katas et initiation gratuite pour les curieux.',
  },
  {
    date: '2027-05-16',
    day: '16',
    month: 'Mai',
    title: 'Open international Jeunes',
    place: 'Barcelone, Espagne',
    category: 'competition',
    detail: 'Déplacement du groupe compétition sur trois jours, encadré par les enseignants.',
  },
  {
    date: '2027-06-26',
    day: '26',
    month: 'Juin',
    title: 'Fête de fin de saison',
    place: 'Complexe Fondada, Castelnau',
    category: 'adherents',
    detail: 'Remise des ceintures, repas partagé et remerciements aux bénévoles.',
  },
]

export const NEWS = [
  {
    date: '12 septembre 2026',
    title: 'Reprise des cours : le dojo rouvre ses portes',
    text: 'Les entraînements reprennent le lundi 14 septembre. Deux cours d’essai gratuits sont offerts tout le mois.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e5609f65-af4c-4ad0-a5ee-965f6a5f1406.jpg',
  },
  {
    date: '28 juin 2026',
    title: 'Trois podiums au championnat régional',
    text: 'Nos compétiteurs ramènent un titre en kata individuel et deux médailles de bronze en kumite.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7bc46f80-2440-4d50-b90f-72b25c176908.jpg',
  },
  {
    date: '14 juin 2026',
    title: 'Le club dévoile sa nouvelle identité visuelle',
    text: 'Un samouraï, un katana et les couleurs rouge et or pour incarner les sept valeurs du Bushido.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ee60ec19-ac7d-44c5-bebb-1d77964941a3.jpg',
  },
]

export const RESULTS = [
  { athlete: 'Léa Fontaine', rank: '1ʳᵉ place', event: 'Championnat régional Kata — Minimes', year: '2026' },
  { athlete: 'Hugo Delmas', rank: '3ᵉ place', event: 'Coupe départementale Kumite — Cadets', year: '2026' },
  { athlete: 'Équipe Kata Seniors', rank: '2ᵉ place', event: 'Open de Midi-Pyrénées', year: '2026' },
  { athlete: 'Inès Bouzid', rank: '1ʳᵉ place', event: 'Challenge jeunes Occitanie — Benjamines', year: '2025' },
]
